<!-- BottomComponent.vue -->
<template>
  <div class="">
    <h2>Bottom Component</h2>
    <!-- Contenido del componente Bottom -->
  </div>
</template>

<script>
import "@/assets/style.css"

export default {
  name: 'BottomComponent',
};
</script>